import { Link } from 'react-router-dom';
import { Mail, MapPin, Linkedin, Instagram, Facebook } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_74b64d1e-0f50-41cd-a085-d4779dba4423/artifacts/32j43v4s_Wild%20Thyme%20Logo.png";

export const Footer = () => {
  return (
    <footer className="bg-[#3A4A3F] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-2 font-serif text-2xl font-semibold mb-4">
              <img src={LOGO_URL} alt="Wild Thyme" className="w-8 h-8 object-contain" />
              Wild Thyme
            </div>
            <p className="text-white/80 leading-relaxed">
              Trusted guides creating authentic outdoor experiences for adventure and wellbeing.
            </p>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4">Quick Links</h3>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-white/80 hover:text-[#D4A373] transition-colors" data-testid="footer-link-home">
                Home
              </Link>
              <Link to="/about" className="text-white/80 hover:text-[#D4A373] transition-colors" data-testid="footer-link-about">
                About
              </Link>
              <Link to="/experiences" className="text-white/80 hover:text-[#D4A373] transition-colors" data-testid="footer-link-experiences">
                Experiences
              </Link>
              <Link to="/book" className="text-white/80 hover:text-[#D4A373] transition-colors" data-testid="footer-link-book">
                Book Now
              </Link>
              <Link to="/contact" className="text-white/80 hover:text-[#D4A373] transition-colors" data-testid="footer-link-contact">
                Contact
              </Link>
            </div>
          </div>
          <div>
            <h3 className="font-semibold text-lg mb-4">Contact</h3>
            <div className="flex flex-col gap-3 mb-6">
              <div className="flex items-center gap-2 text-white/80">
                <Mail className="w-5 h-5" />
                <a href="mailto:team@wild-thyme.co.uk" className="hover:text-[#D4A373] transition-colors" data-testid="footer-email">
                  team@wild-thyme.co.uk
                </a>
              </div>
              <div className="flex items-center gap-2 text-white/80">
                <MapPin className="w-5 h-5" />
                <span>United Kingdom</span>
              </div>
            </div>
            
            {/* Social Media Icons */}
            <div>
              <h3 className="font-semibold text-lg mb-4">Follow Us</h3>
              <div className="flex items-center gap-4">
                <a
                  href="https://www.linkedin.com/in/wild-thyme-4331673ab/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Follow Wild Thyme on LinkedIn"
                  data-testid="footer-linkedin"
                >
                  <Linkedin className="w-5 h-5 text-white" />
                </a>
                <a
                  href="https://www.instagram.com/wild_thyme12/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Follow Wild Thyme on Instagram"
                  data-testid="footer-instagram"
                >
                  <Instagram className="w-5 h-5 text-white" />
                </a>
                <a
                  href="https://www.facebook.com/share/1VMeT3Em1u/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 bg-white/10 hover:bg-white/20 rounded-full flex items-center justify-center transition-all duration-300 hover:scale-110"
                  aria-label="Follow Wild Thyme on Facebook"
                  data-testid="footer-facebook"
                >
                  <Facebook className="w-5 h-5 text-white" />
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-white/20 mt-12 pt-8 text-center text-white/60 text-sm">
          <p>&copy; {new Date().getFullYear()} Wild Thyme. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
